<template>
  <zm-dialog :modelValue="modelValue"
    width="600px" :title="$t('billing.success.coppa.data_collection_practice' )"
    id="coppa_dialog">
    <h3>{{$t('billing.success.coppa.your_org_info')}}</h3>
    <label class="coppa-label">{{$t('billing.common.company_organization')}}</label>
    <p class="coppa-value" style="margin-bottom:10px;">{{orgName}}</p>
    <label class="coppa-label">{{$t('billing.address')}}</label>
    <p class="coppa-value">{{address}}</p>
    <zm-form ref="form" :model="form" :rules="rules" @submit.prevent>
      <h3 style="margin-top: 25px">{{$t('billing.success.coppa.org_website')}}</h3>
        <zm-form-item prop="websiteAddress">
          <zm-input data-testid="checkout-input-424" type="text" pass-by-max-length :maxlength="500" v-model="form.websiteAddress"
                :aria-label="$t('billing.success.coppa.org_website')" :readonly="submitting"></zm-input>
        </zm-form-item>
      <h3 style="margin-top: 25px">{{$t('billing.success.coppa.your_role_in_org')}}</h3>
      <zm-form-item prop="orgRole">
          <zm-radio-group v-model="form.orgRole" name="role-in-org" vertical :disabled="submitting">
              <zm-radio data-testid="checkout-radio-425" :label="1">{{$t('billing.success.coppa.superintendent')}}</zm-radio>
              <zm-radio data-testid="checkout-radio-426" :label="2">{{$t('billing.success.coppa.teacher')}}</zm-radio>
              <zm-radio data-testid="checkout-radio-427" :label="3">{{$t('billing.success.coppa.other')}}</zm-radio>
          </zm-radio-group>
      </zm-form-item>
      <template v-if="isRoleOther">
          <h3 style="margin-top: 25px">{{$t('billing.success.coppa.name_of_superintendent')}}</h3>
          <zm-form-item prop="orgAdminName">
              <zm-input data-testid="checkout-input-428" type="text" pass-by-max-length :maxlength="256" v-model="form.orgAdminName"
                :aria-label="$t('billing.success.coppa.name_of_superintendent')" :readonly="submitting"></zm-input>
          </zm-form-item>
          <h3 style="margin-top: 25px">{{$t('billing.success.coppa.email_of_above')}}</h3>
          <zm-form-item prop="orgAdminEmail">
              <zm-input data-testid="checkout-input-429" type="text" pass-by-max-length :maxlength="256" v-model="form.orgAdminEmail"
                    :aria-label="$t('billing.success.coppa.email_of_above')" :readonly="submitting"></zm-input>
          </zm-form-item>
      </template>
    </zm-form>
    <template #footer>
    <div class="btn-container-right">
      <zm-button data-testid="checkout-button-430" type="primary" @click="onSubmitClick" :loading="submitting">{{$t('billing.continue')}}</zm-button>
      <zm-button data-testid="checkout-button-431" type="default" @click="closeDialog" :disabled="submitting">{{$t('common.btn_cancel')}}</zm-button>
    </div>
    </template>
  </zm-dialog>
</template>

<script>
import { translation } from '@/plugins/i18n';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const requiredMessage = translation('billing.error.field_required');
    const requiredRule = { required: true, message: requiredMessage, trigger: 'change' };
    const orgRoleLazyRule = {
      trigger: 'change',
      validator: (rule, value, callback) => {
        if (!this.shouldValidateOrgRole) {
          callback();
          return;
        }
        if (value) {
          callback();
        } else {
          callback(new Error(requiredMessage));
        }
      }
    };
    let contact = {};
    if (window.newBillingConfig?.soldToContact4Edu) {
      contact = JSON.parse(window.newBillingConfig?.soldToContact4Edu);
    }
    return {
      contact: contact,
      orgName: contact.companyName,
      submitting: false,
      form: {
          websiteAddress: '',
          orgRole: '',
          orgAdminName: '',
          orgAdminEmail: ''
      },
      shouldValidateOrgRole: false,
      rules: {
          orgRole: [orgRoleLazyRule],
          orgAdminName: [requiredRule],
          orgAdminEmail: [
              requiredRule,
              { type: 'email', message: translation('billing.error.email_invalid_address'), trigger: ['blur', 'change'] }
          ]
      }
    }
  },
  methods: {
    onSubmitClick () {
      var me = this
      this.shouldValidateOrgRole = true;
      this.$refs.form?.validate().then(() => {
        me.submitDialog()
      })
    },
    submitDialog () {
      this.submitting = true
      var postData = Object.assign(this.form, {
        coppa: this.$config("coppa") || '1',
        soldToContact: this.$config("soldToContact4Edu") || '',
        id: this.$config("coppaId") || ''
      })
      if (!this.isRoleOther) {
          postData.orgAdminName = ''
          postData.orgAdminEmail = ''
      }
      SB?.postForm('/buy/coppa/update', postData);
    },
    closeDialog () {
      if (this.submitting) {
          return false
      }
      this.$emit('update:modelValue', false);
    },
  },
  watch: {
    modelValue (val) {
      if (!val) {
        this.shouldValidateOrgRole = false;
        this.$nextTick(() => this.$refs.form?.clearValidate(['orgRole']));
      }
    }
  },
computed: {
    isRoleOther: function () {
      return this.form.orgRole == 3
    },
    address: function () {
      return [
        this.contact.address2,
        this.contact.city,
        this.contact.state,
        this.contact.country,
        this.contact.zip
      ].filter(function (item) {
          return item && item.trim().length > 0
      }).join(', ')
    }
}
}
</script>

<style lang="scss">
#coppa_dialog h3 {
    font-size: 14px;
    line-height: 24px;
    color: #000000;
    font-weight: 700;
    margin-bottom: 0;
}
#coppa_dialog label.coppa-label {
    font-size: 14px;
    line-height: 18px;
    color: rgba(4, 4, 19, 0.56);
}
#coppa_dialog p.coppa-value {
    font-size: 14px;
    line-height: 24px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
}
#coppa_dialog .btn-container-right {
    display: flex;
    justify-content: flex-end;
}
#coppa_dialog .zbo-form-item {
    position: relative;
}
#coppa_dialog .zbo-form-item__error {
    position: static;
    margin-top: 4px;
}
#coppa_dialog .error-msg {
    margin-top: 5px;
}
#coppa_dialog .error-msg > i {
    font-size: 12px;
    color: #FF4242;
    margin-right: 5px;
}
#coppa_dialog .error-msg > span {
    font-size: 14px;
    color: #E02828;
    line-height: 24px;
}
#coppa_dialog .zbo-form-item__asterisk {
    display: none;
}
#coppa_dialog .zbo-radio__inner{
    margin-top: -8px;
}
</style>
